import api from './api';

export const groupService = {
  getGroups: async (projectId) => {
    const response = await api.get('/groups', { params: { project: projectId } });
    return response.data;
  },

  getGroup: async (id) => {
    const response = await api.get(`/groups/${id}`);
    return response.data;
  },

  createGroup: async (data) => {
    const response = await api.post('/groups', data);
    return response.data;
  },

  updateGroup: async (id, data) => {
    const response = await api.put(`/groups/${id}`, data);
    return response.data;
  },

  deleteGroup: async (id) => {
    const response = await api.delete(`/groups/${id}`);
    return response.data;
  }
};
